import React from "react";
import PropTypes from "prop-types";

const sizeClasses = {
  sm: "w-screen lg:w-[30%]",
  md: "w-full lg:w-[50%]",
  lg: "w-full lg:w-[75%]",
  xl: "w-full",
};

const Modal = ({
  isOpen,
  onClose,
  children,
  size = "md",
  scrollable = true,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
      <div
        className={`relative bg-white rounded-lg shadow-lg ${
          sizeClasses[size]
        } ${scrollable ? "max-h-[90vh] overflow-y-auto" : ""} p-6`}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-gray-900 text-2xl font-bold"
          aria-label="Close modal"
        >
          &times;
        </button>

        {/* Modal Content */}
        {children}
      </div>
    </div>
  );
};

// Optional: Add prop types for better DX
Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
  scrollable: PropTypes.bool,
};

export default Modal;
